export default __webpack_public_path__ + "static/media/SpiffyUserHome.78c06a1b.png";